import {
  getEmployees as getEmployeesService,
  createEmployee as createEmployeeService,
  updateEmployee as updateEmployeeService,
  getOrgTree as getOrgTreeService,
} from "services/company/employee/employeeService";
import { getEmployeeWorkload as getEmployeeWorkloadService } from "services/company/projectManagement/project/projectService";
import {
  getEmployeesStart,
  getEmployeesSuccess,
  getEmployeesFailure,
  createEmployeeStart,
  createEmployeeSuccess,
  createEmployeeFailure,
  updateEmployeeStart,
  updateEmployeeSuccess,
  updateEmployeeFailure,
  getWorkloadsStart,
  getWorkloadsSuccess,
  getWorkloadsFailure,
  getOrgTreeStart,
  getOrgTreeSuccess,
  getOrgTreeFailure,
} from "./employeeSlice";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch all employees
export const fetchEmployees = () => async (dispatch) => {
  try {
    dispatch(getEmployeesStart());
    const response = await getEmployeesService();

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getEmployeesSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to fetch employees";
      dispatch(getEmployeesFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch employees error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch employees";
    dispatch(getEmployeesFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Fetch employee workloads
export const fetchEmployeeWorkloads = () => async (dispatch) => {
  try {
    dispatch(getWorkloadsStart());
    const response = await getEmployeeWorkloadService();

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getWorkloadsSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to fetch employee workloads";
      dispatch(getWorkloadsFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch workloads error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch employee workloads";
    dispatch(getWorkloadsFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Create a new employee
export const createNewEmployee = (employeeData) => async (dispatch) => {
  try {
    dispatch(createEmployeeStart());
    const response = await createEmployeeService(employeeData);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(createEmployeeSuccess(response.data));
      showSuccessToast(
        response?.meta?.message || "Employee created successfully!"
      );
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to create employee";
      dispatch(createEmployeeFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Create employee error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to create employee";
    dispatch(createEmployeeFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Update an employee
export const updateExistingEmployee =
  (employeeId, employeeData) => async (dispatch) => {
    try {
      dispatch(updateEmployeeStart());
      const response = await updateEmployeeService(employeeId, employeeData);

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(updateEmployeeSuccess(response.data));
        showSuccessToast(
          response?.meta?.message || "Employee updated successfully!"
        );
        return { success: true, data: response.data };
      } else {
        const errorMsg = response?.meta?.message || "Failed to update employee";
        dispatch(updateEmployeeFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Update employee error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to update employee";
      dispatch(updateEmployeeFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };

// Fetch employee organization tree hierarchy
export const fetchOrgTree = () => async (dispatch) => {
  try {
    dispatch(getOrgTreeStart());
    const response = await getOrgTreeService();

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getOrgTreeSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to fetch organization tree";
      dispatch(getOrgTreeFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch organization tree error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch organization tree";
    dispatch(getOrgTreeFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};
